import styled from "styled-components"

const ContentContainer = styled.div`
  color: inherit;
  max-height: 100%;
  .carouselContainer:hover {
    > button {
      opacity: 1;
    }
  }
`

export { ContentContainer }
